import { NgModule } from '@angular/core';
import { ClientSignUpConfirmComponent } from './client-sign-up-confirm.component';
import { CommonModule } from '@angular/common';
import { ClientSignUpConfirmRoutingModule } from './client-sign-up-confirm-routing.module';
import { NzInputModule } from 'ng-zorro-antd/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { FormFieldModule } from 'src/app/_shared/components/form-field';
import { MessageModule } from 'src/app/_shared/components/message';
import { SpinnerComponent } from 'src/app/_shared/components/spinner/spinner.component';
import { FooterComponent } from 'src/app/footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ClientSignUpConfirmComponent],
  imports: [
    CommonModule,
    ClientSignUpConfirmRoutingModule,
    FooterComponent,
    FormsModule,
    ReactiveFormsModule,
    FormFieldModule,
    NzFormModule,
    NzGridModule,
    TranslateModule,
    NzInputModule,
    NzButtonModule,
    FormFieldModule,
    NzIconModule,
    NzButtonModule,
    SpinnerComponent,
    MessageModule,
  ],
})
export class ClientSignUpConfirmModule {}
